import { NativeModules, Platform } from 'react-native'
import filter from 'lodash/filter';
import isEmpty from 'lodash/isEmpty';
import orderBy from 'lodash/orderBy';
import map from 'lodash/map';
import get from "lodash/get";

export const _getOffersList = async (lob, searchString) => {
  try {
    let offersList = await getOfferDetailsV2(lob);
    const lobUpperCase = lob.toUpperCase();
    let newOfferList = filter(offersList, (offer) => {
      return offer.lob?.includes(lobUpperCase);
    });

    if (newOfferList.length > 0) {
      try {
        newOfferList = map(newOfferList, (originalOfferObj) => {
          const newOfferObject = {};
          let promoTitle = originalOfferObj.pTl;
          if (!isEmpty(originalOfferObj.dStxt) && !isEmpty(originalOfferObj.offerTxt)
            && !isEmpty(originalOfferObj.dEtxt)) {
            promoTitle = `${originalOfferObj.dStxt} ${originalOfferObj.offerTxt} ${originalOfferObj.dEtxt}`;
          }
          newOfferObject.newHeroOfferCardUrl = originalOfferObj.newHeroOfferCardUrl;
          newOfferObject.promoTitle = promoTitle;
          newOfferObject.promoMessage = originalOfferObj.pTl;
          newOfferObject.promoCode = originalOfferObj.cc;
          newOfferObject.url = originalOfferObj.url;
          newOfferObject.dis = originalOfferObj.dis;
          newOfferObject.heroUrl = originalOfferObj.heroUrl;
          newOfferObject.skyImageUrl = originalOfferObj.skyBigFullImgUrl;
          newOfferObject.skyBigFullImgUrl = originalOfferObj.skyBigFullImgUrl;
          return newOfferObject;
        });
        newOfferList = orderBy(newOfferList, ['dis'], ['desc']);
      } catch (e) {
        newOfferList = [];
      }
    }
    return newOfferList;
  } catch (e) {
    return [];
  }
};


const getCookieValue = (name) => {
  if (Platform.OS !== "web") return '';
  return document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || '';
}

const getOfferDetailsV2 = async (lob) => {
  const response = await fetch('https://mapi.makemytrip.com/empeiria/api/v1/pwarails', {
    method: 'POST',
    headers: {
      'Authorization': 'h4nhc9jcgpAGIjp',
      'Accept': 'application/json',
      'content-type': 'application/json',
      'os': 'pwa',
      'currency': "inr",
      'region': "in",
      'language': getCookieValue("lang") || "eng",
    },
    body: JSON.stringify({
      "user": {
          "location": {}
      },
      "refreshFlags": {},
      "userEvents": {
          "searchEvents": {}
      },
      "context": {}
    })
  });
  const offers = await response.json();
  const railsOffers = get(offers, "sequenceData.BASE_SHEET.cardSequence.data", []);
  if (railsOffers.length) {
    const id = railsOffers[0].id;
    return get(offers, `data.BASE_SHEET.cardData.${id}.data.pM`, {})
  }
  return [];
}

NativeModules.OffersModule = {
  getOffers: _getOffersList
};
